import { apiRequest } from "../_core/apiRequest";
import { unwrapProfileResponse } from "./profileResponseEnvelope";

export async function getProfileEntitlements(options = {}) {
  const scope = String(options?.scope || "").trim();
  const response = await apiRequest({
    method: "get",
    path: "/profile/entitlements",
    params: scope ? { scope } : undefined,
    errorMessage: "Erro ao buscar funcionalidades da conta",
  });

  return unwrapProfileResponse(response);
}
